import { Injectable } from '@angular/core';
import { TokenResponse } from 'angular-oauth2-oidc';
import { Observable, switchMap } from 'rxjs';
import { AppConfigService } from '../app-config.service';
import { AuthService } from './auth.service';
import { GatewayAuthService } from './gateway-auth.service';
import { KeycloakAuthService } from './keycloak-auth.service';

@Injectable()
export class AuthProxyService extends AuthService {
  constructor(
    private readonly appConfigService: AppConfigService,
    private readonly keycloakAuth: KeycloakAuthService,
    private readonly gatewayAuth: GatewayAuthService
  ) {
    super();
  }

  private get delegate(): AuthService {
    return this.appConfigService.getConfig()?.gatewayLogin === true ? this.gatewayAuth : this.keycloakAuth;
  }

  get isAuthenticated$(): Observable<boolean> {
    return this.appConfigService.configLoaded$.pipe(switchMap(() => this.delegate.isAuthenticated$));
  }

  get isDoneLoading$(): Observable<boolean> {
    return this.appConfigService.configLoaded$.pipe(switchMap(() => this.delegate.isDoneLoading$));
  }

  runInitialLoginSequence(): Promise<void> {
    return this.delegate.runInitialLoginSequence();
  }

  login(): void {
    this.delegate.login();
  }

  logout(): void {
    this.delegate.logout();
  }

  refresh(): Promise<TokenResponse> {
    return this.delegate.refresh();
  }

  isLogged(): boolean {
    return this.delegate.isLogged();
  }

  get accessToken(): string {
    return this.delegate.accessToken;
  }

  get refreshToken(): string {
    return this.delegate.refreshToken;
  }
}
